const OTKRYTIEPRIVATEKEY = 'otkrytie_private';
const STAGOTKRYTIEPRIVATEKEY = 'q_otkrytie_privat';
const OTKRYTIEKEY = 'q_otkrytie';
const MTSTARIFFKEY = 'mts';
const CARCADETARIFFKEY = 'carcade';
const TRIALTARIFFKEY = 'trial';
const OTPPRIVATETARIFFKEY = 'otp_private';
const OTPVIPTARIFFKEY = 'otp_vip';
const OTPTARIFFKEY = 'otp_konsierge';
const MTSPREMIUMTARIFFKEY = 'mts_premium';
const MTSSTATUSTARIFFKEY = 'mts_status';
const MTSPRIVATETARIFFKEY = 'mts_private';
const MTSPREMIUM531733TARIFFKEY = 'MTS_Premium_531733';
const MTSPRIVATEPLUSTARIFFKEY = 'mts_private_plus';
const GPBKEY = 'q_gpbank';
const ALFAKEY = 'alfa_konsierge';
const ALFAONLYKEY = 'alfa_only';
const ACLUBKEY = 'a_club';
const ACLUBKONSIERGEKEY = 'a_club_konsierge';
const SPB_PRIVATE_TARIFF_KEY = 'spb_private';
const SPB_SERVICE_KEY = 'spb';
const SOVCOM_SERVICE_KEY = 'sovcombank';

export const gpbAirbackInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы в России.'
    },
    {
        'title': 'Как получить лимиты на бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком.'
    },
    {
        'title': 'Проходы бесплатные?',
        'text': 'Да, Банк начисляет определенное количество бесплатных проходов в зависимости от выполненных условий. Это количество отображается в разделе Бизнес-залы.  '
    },
    {
        'title': 'Как получить визит в бизнес-зал?',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу Persona.Aero – это можно сделать через поле поиска в разделе Бизнес-залы.РФ. После этого пополните QR-код на нужное количество визитов.'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество оформленных визитов и спишет требуемое количество. Один пассажир – один визит.'
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Конечно, просто укажите общее количество людей при пополнении QR-кода.'
    },
    {
        'title': 'Могу ли я передавать свой qr-код третьим лицам?',
        'text': 'Нет, qr-код именной и выписан на имя основного держателя карты, третьи лица без вашего присутствия не смогут им воспользоваться.'
    },
    {
        'title': 'Могу ли я приобрести дополнительные визиты, когда у меня закончились бесплатные проходы от Банка?',
        'text': 'Да, вы можете оплатить неограниченное количество проходов. Важно отметить, что купленные проходы не подлежат компенсации.'
    },
    {
        'title': 'А можно отменить оформленные визиты?',
        'text': 'Нет, сертификаты невозвратные.'
    },
    {
        'title': 'При наличии оформленного визита я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'QR-код действует в любом аэропорту?',
        'text': 'Да, оплаченные визиты можно использовать в любом аэропорту-участнике программы по России.'
    },
    {
        'title': 'Сколько действует QR-код?',
        'text': '14 дней с момента оплаты'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов по России и заграницей разные?',
        'text': 'Да.'
    },
    {
        'title': 'Почему я не вижу доступных проходов?',
        'text': 'Если вы не видите доступных проходов в разделе Задачи, это может значить, что нам еще не поступила информация от Банка или вы не выполнили требуемые условия для получения привилегий. Вы можете уточнить детали по номеру <a href="tel:+74957191911">+7 495 719 19 11</a> или <a href="tel:88007191911">8 800 719 19 11</a>. К сожалению, это вся информация, которая у нас есть по данному вопросу'
    },
    {
        'title': 'Если у вас остались вопросы, напишите нам в чат 😊',
        'text': ''
    }];

export const otkrytiePrivateAirbackInfo = [
    {
        title: '– Как это работает?',
        text: '– Все просто. Вы оплачиваете проход в бизнес-залы по России в модуле «Бизнес-залы.РФ» в данном приложении картой банка с программой лояльности МАКС. Услуга доступна для карт с тарифами Opencard, PB Club, PB People, «Все, что надо».\nМаксимальная сумма покупки к возмещению в рамках одного Airback — 3000 рублей. После оплаты Вы увидите в приложении покупки, доступные к возмещению, в течение суток. Начисление бонусных рублей после подтверждения возмещения происходит моментально.\nЕсли возникнут вопросы при бронировании бизнес-залов, вы не найдете нужный зал или город, возникнут вопросы по процедуре оформления прохода, пожалуйста, обратитесь в чат приложения или по телефону <a href="tel:+74959098048">+7&nbsp;495&nbsp;909&nbsp;8048</a>. Менеджер с радостью поможет во всем разобраться.'
    },
    {
        title: '– QR-коды для залов по России и за границей разные?',
        text: '– Да, это совершенно разные программы. При бронировании бизнес-залов в России в разделе «Бизнес-залы.РФ» используются QR-коды по программе Persona.Aero, а при бронировании бизнес-залов за рубежом в разделе «Бизнес-залы.Мир» - по программе Dragon Pass.'
    },
    {
        title: '– Залы надо бронировать заранее?',
        text: '– Нет, достаточно внести оплату за 5 минут до посещения зала.'
    },
    {
        title: '– Где я могу посмотреть QR-код?',
        text: '– QR-код появляется автоматически после информации об оплате. Его всегда можно посмотреть в модуле «Бизнес-залы.РФ» по кнопке «Мои QR-коды». Данный сертификат нужно предъявить сотруднику бизнес-зала.'
    },
    {
        title: '– Сколько проходов по QR-кодам я могу оплатить за один раз?',
        text: '– Сколько угодно. Можно оплатить несколько проходов и использовать их в разных аэропортах, так как Ваш уникальный код един для все бизнес-залов. Количество доступных проходов будет отображаться в разделе «Бизнес-залы.РФ» на кнопке «Ваш QR-код». Кнопка «История» покажет все операции по списанию и пополнению.'
    },
    {
        title: '– Я могу оплатить проход для другого человека?',
        text: '– Конечно! Воспользуйтесь кнопкой «Код» для другого пассажира в разделе «Бизнес-залы». Его также можно пополнить на любое число проходов. После пополнения на забудьте отправить код этому человеку по почте или через любой мессенджер.'
    },
    {
        title: '– А взять с собой других пассажиров можно?',
        text: '– Конечно. Просто укажите общее количество людей при оплате прохода.'
    },
    {
        title: '– А как с возможностью отменить проход?',
        text: '– Отменить проход можно в любой момент в течение 60 дней после оплаты. Оплата будет возвращена на карту в полном объеме.'
    },
    {
        title: '– Если мне нужно забронировать бизнес-зал, например, на троих человек — оформлять три отдельных бронирования?',
        text: '– Нет, все проще. Укажите всех пассажиров в одной форме (кнопка «+» в меню «Количество гостей»).'
    },
    {
        title: '– А сколько это стоит?',
        text: '– Для бизнес-залов действует единый тариф — 2 489 рублей.'
    },
    {
        title: '– А что делать, если Airback’и не начислили?!!',
        text: '– Напишите в чат мобильного приложения банка или позвоните на линию <a href="tel:+74952240222">+7 495 224 02 22 </a>или <a href="tel:88002220222">8 800 222 02 22</a> .'
    },
    {
        title: '– Напомните, как называется программа бронирования бизнес-залов?',
        text: '– Persona.Aero.'
    },
    {
        text: 'С условиями предоставления данного сервиса вы можете ознакомиться на сайте <a href="https://pb.open.ru/airback">pb.open.ru/airback</a>'
    },
];

export const otkrytiePrivateDragonPassInfo = [
    {
        title: '– Что это за сервис?',
        text: '– В дополнение к модулю «Бизнес-залы.РФ» по компенсации проходов в бизнес-залы аэропортов России мы запустили аналогичный модуль «Бизнес-залы.Мир» для проходов в аэропортах за рубежом с большим покрытием (свыше 1000 залов).'
    },
    {
        title: '– Как это работает?',
        text: '– Вы оплачиваете проход в бизнес-зал в данном приложении картой банка с программой лояльности МАКС. Услуга доступна для карт с тарифами Opencard, PB Club, PB People, «Все, что надо».\n' +
            'Максимальная сумма покупки к возмещению в рамках одного Airback — 3000 рублей. После оплаты Вы увидите в приложении покупки, доступные к возмещению, в течение суток. Начисление бонусных рублей после подтверждения возмещения происходит моментально.\n' +
            '\n' +
            '– Необходимо приобрести сертификат Dragon Pass на нужное количество проходов через модуль «Бизнес-залы.Мир». Один пассажир – один проход. После оплаты сертификат с QR-кодом будет отображаться в разделе «Бизнес-залы.Мир». Данный сертификат нужно предъявить сотруднику бизнес-зала.\n' +
            '\n' +
            'Обратите внимание, что сертификат одноразовый. Если вы купили сертификат на 2 прохода, но пройдет только один пассажир, сертификат будет считаться использованным – таковы правила Dragon Pass.\n' +
            '\n' +
            'В нашем приложении Вы можете воспользоваться услугой бронирования бизнес-залов по всему миру. Если возникнут вопросы при бронировании бизнес-залов, вы не найдете нужный зал или город, возникнут вопросы по процедуре оформления прохода, пожалуйста, обратитесь в чат приложения или по телефону <a href="tel:+74959098048">+7&nbsp;495&nbsp;909&nbsp;8048</a>. Менеджер с радостью поможет во всем разобраться.'
    },
    {
        title: '– QR-коды для залов по России и заграницей разные?',
        text: '– Да, это совершенно разные программы. При бронировании бизнес-залов в России в разделе «Бизнес-залы.РФ» используются QR-коды по программе Persona.Aero, а при бронировании бизнес-залов за рубежом в разделе «Бизнес-залы.Мир» - по программе Dragon Pass.'
    },
    {
        title: '– Бронировать залы надо заранее?',
        text: '– Нет, достаточно внести оплату за 5 минут до посещения зала.'
    },
    {
        title: '– Где я могу посмотреть QR-код?',
        text: '– После оплаты сертификат с QR-кодом будет отображаться в разделе «Бизнес-залы.Мир». Данный сертификат нужно предъявить сотруднику бизнес-зала.'
    },
    {
        title: '– Сколько проходов по QR-кодам я могу оплатить за один раз?',
        text: '– Сколько угодно. Можно оплатить несколько проходов и использовать их в разных аэропортах, так как Ваш уникальный код един для все бизнес-залов. Количество доступных проходов будет отображаться в разделе «Бизнес-залы.МИР» на кнопке «Ваш QR-код». Кнопка «История» покажет все операции по списанию и пополнению.'
    },
    {
        title: '– Я могу оплатить проход для другого человека?',
        text: '– Конечно! Воспользуйтесь кнопкой «Код» для другого пассажира в разделе «Бизнес-залы». Его также можно пополнить на любое число проходов. После пополнения на забудьте отправить код этому человеку по почте или через любой мессенджер.'
    },
    {
        title: '– А взять с собой других пассажиров можно?',
        text: '– Конечно. Просто укажите общее количество людей при оплате прохода.'
    },
    {
        title: '– А можно отменить проходы?',
        text: '– К сожалению, нет. Оплаченные сертификаты не подлежат возврату.'
    },
    {
        title: '– Если мне нужно забронировать бизнес-зал, например, на троих человек — оформлять три отдельных бронирования?',
        text: '– Нет, все проще. Укажите всех пассажиров в одной форме (кнопка «+» в меню «Количество гостей»).'
    },
    {
        title: '– Сколько действует сертификат?',
        text: '– 60 дней с момента оплаты.'
    },
    {
        title: '– А сколько это стоит?',
        text: '– Для бизнес-залов действует единый тариф — 2 489 рублей.'
    },
    {
        title: '– Что делать, если Airback’и не начислили?',
        text: '– Напишите в чат мобильного приложения банка или позвоните на линию <a href="tel:+74952240222">+7 495 224 02 22 </a>или <a href="tel:88002220222">8 800 222 02 22</a> , и мы исправим ситуацию в ближайшее время.'
    },
    {
        title: '– Напоните, как называется программа бронирования бизнес-залов?',
        text: '– Dragon Pass.'
    },
    {
        text: 'С условиями предоставления данного сервиса Вы можете ознакомиться на сайте <a href="https://pb.open.ru/airback">pb.open.ru/airback</a>'
    },
];

export const defaultAirbackInfo = [
    {
        title: '- Как это работает?',
        text: '- Все просто. Вы оплачиваете проход в бизнес-зале в данном приложении любой картой банка Открытие с программой лояльности МАКС. Максимальная сумма покупки к возмещению – 3000 рублей. После оплаты вы увидите покупку, доступную к возмещению, в течение суток. Начисление бонусных рублей после подтверждения возмещения происходит моментально'
    },
    {
        title: '- Залы надо бронировать заранее?',
        text: '- Нет, достаточно пополнить баланс за 5 минут до посещения зала.'
    },
    {
        title: '- Сколько проходов по QR-кодам я могу оплатить за один раз?',
        text: '- Сколько душе угодно 😊 Вы можете оплатить несколько проходов и использовать их в разных аэропортах, так как полученный вами уникальный код един для все бизнес-залов. Количество доступных проходов будет отображаться в разделе «Бизнес-залы» на кнопке «Ваш QR-код». Кнопка «История» покажет все операции по списанию и пополнению.'
    },
    {
        title: '- Я могу оплатить проход для другого человека?',
        text: '- Конечно! Воспользуйтесь кнопкой Код для другого пассажира на главной форме раздела Бизнес-залы. Его также можно пополнить на любое число проходов. После пополнения на забудьте отправить код этому человеку по почте или через любой мессенджер.'
    },
    {
        title: '- А взять с собой других пассажиров можно?',
        text: '- Еще бы! Просто укажите общее количество людей при оплате прохода.'
    },
    {
        title: '- А как с возможностью отменить проход? Волнуюсь…',
        text: '- Не надо 😊 в случае QR-кода вы можете отменить проход в любой момент в течение 2 месяцев после оплаты, средства будут возвращены на карту в полном объеме.'
    },
    {
        title: '- Так а сколько это стоит, я так и не понял?..',
        text: '- В настоящий момент действует единая стоимость – 2489 рублей за один проход.'
    },
    {
        title: '- А что делать, если Airback’и не начислили?!!',
        text: 'Не надо беспокоиться. Если покупка не отображается в списке доступных для возмещения или бонусные рубли не начислены на счёт после подтверждения возмещения, вы можете написать в чат интернет-банкинга или позвонить на линию для премиальных клиентов <a href=\'tel:+88004444477\'>8 (800) 444 44 77</a>.'
    },
    {
        title: '- И как, еще раз, называется эта программа, если меня вдруг в зале спросят?..',
        text: '- Persona.Aero! Не благодарите 😊'
    },
];

export const sovcomDragonInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам бесплатные проходы в бизнес-залы за границей. Количество доступных проходов в месяц может различаться в зависимости от вашего уровня в Банке.'
    },
    {
        'title': 'Как получить визит в бизнес-зал?',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу DragonPass – это можно сделать через поле поиска в разделе Бизнес-залы.Мир. После этого выпишите сертификат, нажав «Выписать сертификат».'
    },
    {
        'title': 'Что я получаю после выписки сертификата?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество гостей, которые могут пройти с вами.'
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Да, в рамках лимита ваших привилегий. Просто укажите общее количество людей при выписке сертификата.'
    },
    {
        'title': 'Могу ли я передавать свой qr-код третьим лицам?',
        'text': 'Нет, qr-код именной и выписан на имя основного клиента, третьи лица без вашего присутствия не смогут им воспользоваться.\nВажно: сертификат на визит одноразовый. Если вы купили сертификат на два визита, а прошёл только один пассажир, сертификат будет считаться использованным.'
    },
    {
        'title': 'А можно отменить оплаченные сертификаты?',
        'text': 'Нет, сертификаты невозвратные.'
    },
    {
        'title': 'При наличии оплаченного визита я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'Сертификат действует в любом аэропорту?',
        'text': 'Выписанный сертификат можно использовать в любом зарубежном аэропорту-участнике программы.'
    },
    {
        'title': 'Сколько действует сертификат?',
        'text': '30 дней с момента оплаты'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов заграницей и по России разные?',
        'text': 'Да.'
    },
    {
        'title': 'Если у вас остались вопросы, напишите нам в чат 😊',
        'text': ''
    }
];

export const mtsAirbackInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы в России.'
    },
    {
        'title': 'Как получить визиты на бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком. '
    },
    {
        'title': 'Как получить визит в бизнес-зал?',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу Persona.Aero – это можно сделать через поле поиска в разделе Бизнес-залы.РФ. После этого пополните QR-код на нужное количество визитов.'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество оформленных визитов и спишет требуемое количество. Один пассажир – один визит. '
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Конечно, до пяти гостей за раз. Просто укажите общее количество людей при пополнении QR-кода. '
    },
    {
        'title': 'А можно отменить оформленные визиты?',
        'text': 'Да, оформленные визиты можно отменить в мобильном приложении.'
    },
    {
        'title': 'При наличии оформленного визита я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'QR-код действует в любом аэропорту?',
        'text': 'Да, оплаченные визиты можно использовать в любом аэропорту-участнике программы по России.'
    },
    {
        'title': 'Сколько действует QR-код?',
        'text': '60 дней с момента оплаты'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов по России и заграницей разные?',
        'text': 'Да.'
    },
    {
        'title': '',
        'text': '<b>Если у вас остались вопросы, напишите нам в чат 😊</b>'
    }];

export const otpAirbackInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы в России.'
    },
    {
        'title': 'Как получить привилегию для прохода в бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком.'
    },
    {
        'title': 'Как оформить проход в бизнес-зал?',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу – это можно сделать через поле поиска в разделе Бизнес-залы.РФ. После этого пополните QR-код на нужное количество проходов.'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. \n' +
            'Просканировав QR-код в сертификате, сотрудник увидит количество оформленных проходов и спишет требуемое количество. Один пассажир – один проход.\n'
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Да, если вы путешествуете с близкими при оформлении сертификата укажите общее количество посетителей. Максимальное количество посетителей - 5 (основной владелец и до 4 гостей).'
    },
    {
        'title': 'А можно отменить оформленные проходы?',
        'text': 'Да, оформленные визиты можно отменить в мобильном приложении.'
    },
    {
        'title': 'При наличии оформленного прохода я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'QR-код действует в любом аэропорту?',
        'text': 'Да, полученные визиты можно использовать в любом аэропорту-участнике программы по России.'
    },
    {
        'title': 'Сколько действует QR-код?',
        'text': '30 дней с момента оформления'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов по России и заграницей разные?',
        'text': 'Да.'
    },
    {
        'title': '',
        'text': '<b>Если у вас остались вопросы, напишите нам в чат 😊</b>'
    }];

export const otpKonsiergeAirbackInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы в России.'
    },
    {
        'title': 'Как получить визиты на бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком. '
    },
    {
        'title': 'Как получить визит в бизнес-зал?',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу – это можно сделать через поле поиска в разделе Бизнес-залы.РФ. После этого пополните QR-код на нужное количество визитов.'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество оформленных визитов и спишет требуемое количество. Один пассажир – один визит. '
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Конечно, до пяти гостей за раз. Просто укажите общее количество людей при пополнении QR-кода. '
    },
    {
        'title': 'А можно отменить оформленные визиты?',
        'text': 'Да, оформленные визиты можно отменить в мобильном приложении.'
    },
    {
        'title': 'При наличии оформленного визита я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'QR-код действует в любом аэропорту?',
        'text': 'Да, полученные визиты можно использовать в любом аэропорту-участнике программы по России.'
    },
    {
        'title': 'Сколько действует QR-код?',
        'text': '30 дней с момента оплаты'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов по России и заграницей разные?',
        'text': 'Да.'
    },
    {
        'title': '',
        'text': '<b>Если у вас остались вопросы, напишите нам в чат 😊</b>'
    }];

export const mtsDragonInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы за границей.'
    },
    {
        'title': 'Как получить лимиты на бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком. '
    },
    {
        'title': 'Как получить визит в бизнес-зал?    ',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу DragonPass – это можно сделать через поле поиска в разделе Бизнес-залы.Мир. После этого выпишите сертификат, нажав на кнопку «Выписать сертификат».'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество гостей, которые могут пройти с вами.'
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Конечно, до пяти гостей за раз. Просто укажите общее количество людей при покупке сертификата. '
    },
    {
        'title': '',
        'text': 'Важно: сертификат на визит одноразовый. Если вы купили сертификат на два визита, а прошёл только один пассажир, сертификат будет считаться использованным.'
    },
    {
        'title': 'А можно отменить оплаченные сертификаты?',
        'text': 'Нет, сертификаты невозвратные.'
    },
    {
        'title': 'При наличии оформленного сертификата я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'Сертификат действует в любом аэропорту?',
        'text': 'Да, купленный сертификат можно использовать в любом зарубежном аэропорту-участнике программы.'
    },
    {
        'title': 'Сколько действует сертификат?',
        'text': '60 дней с момента оплаты'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов заграницей и по России разные?',
        'text': 'Да.'
    },
    {
        'title': '',
        'text': '<b>Если у вас остались вопросы, напишите нам в чат 😊</b>'
    }];

export const otpDragonInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы за границей.'
    },
    {
        'title': 'Как получить привилегию для прохода в бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком.'
    },
    {
        'title': 'Как оформить проход в бизнес-зал?',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу DragonPass – это можно сделать через поле поиска в разделе Бизнес-залы.Мир. После этого выпишите сертификат, нажав на кнопку «Выписать сертификат».'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. ' +
            'Просканировав QR-код в сертификате, сотрудник увидит количество гостей, которые могут пройти с вами.'
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Да, если вы путешествуете с близкими при оформлении сертификата укажите общее количество посетителей. Максимальное количество посетителей - 5 (основной владелец и до 4 гостей).'
    },
    {
        'title': '',
        'text': 'Важно: сертификат на визит одноразовый. Если вы оформили сертификат на два визита, а прошёл только один пассажир, сертификат будет считаться использованным.'
    },
    {
        'title': 'А можно отменить оформленные сертификаты?',
        'text': 'Нет, сертификаты невозвратные.'
    },
    {
        'title': 'При наличии оформленного сертификата я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'Сертификат действует в любом аэропорту?',
        'text': 'Да, оформленный сертификат можно использовать в любом зарубежном аэропорту-участнике программы.'
    },
    {
        'title': 'Сколько действует сертификат?',
        'text': '30 дней с момента оформления'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов заграницей и по России разные?',
        'text': 'Да.'
    },
    {
        'title': '',
        'text': '<b>Если у вас остались вопросы, напишите нам в чат 😊</b>'
    }];

export const otpKonsiergeDragonInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы за границей.'
    },
    {
        'title': 'Как получить лимиты на бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком. '
    },
    {
        'title': 'Как получить визит в бизнес-зал?    ',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу DragonPass – это можно сделать через поле поиска в разделе Бизнес-залы.Мир. После этого выпишите сертификат, нажав на кнопку «Выписать сертификат».'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество гостей, которые могут пройти с вами.'
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Конечно, до пяти гостей за раз. Просто укажите общее количество людей при покупке сертификата. '
    },
    {
        'title': '',
        'text': 'Важно: сертификат на визит одноразовый. Если вы купили сертификат на два визита, а прошёл только один пассажир, сертификат будет считаться использованным.'
    },
    {
        'title': 'А можно отменить оплаченные сертификаты?',
        'text': 'Нет, сертификаты невозвратные.'
    },
    {
        'title': 'При наличии оформленного сертификата я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'Сертификат действует в любом аэропорту?',
        'text': 'Да, полученный сертификат можно использовать в любом зарубежном аэропорту-участнике программы.'
    },
    {
        'title': 'Сколько действует сертификат?',
        'text': '30 дней с момента оплаты'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов заграницей и по России разные?',
        'text': 'Да.'
    },
    {
        'title': '',
        'text': '<b>Если у вас остались вопросы, напишите нам в чат 😊</b>'
    }];

export const alfaAirbackInfo = [
    {
        title: 'Что это за программа?',
        text: 'Здесь вы можете забронировать бизнес-залы в России.'
    },
    {
        title: 'Как получить визит в бизнес-зал?',
        text: 'Проверьте, входит ли нужный вам аэропорт в программу Persona.Aero – это можно сделать через поле поиска в разделе Бизнес-залы.РФ.'
    },
    {
        title: 'Что я получаю после оплаты?',
        text: 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество купленных визитов и спишет требуемое количество. Один пассажир – один визит.'
    },
    {
        title: 'Я могу взять с собой других пассажиров?',
        text: 'Конечно. Просто укажите общее количество людей при покупке визита.'
    },
    {
        'title': 'Могу ли я передавать свой qr-код третьим лицам?',
        'text': 'Нет, qr-код именной.'
    },
    {
        title: 'А можно отменить оплаченные визиты?',
        text: 'Нет, сертификаты (QR-коды) невозвратные.'
    },
    {
        title: 'При наличии оплаченного визита я гарантированно могу попасть в нужный мне бизнес-зал?',
        text: 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        title: 'QR-код действует в любом аэропорту?',
        text: 'Да, оплаченные визиты можно использовать в другом аэропорту-участнике программы по России.'
    },
    {
        title: 'Сколько действует QR-код?',
        text: '30 дней с момента оплаты'
    },
    {
        title: 'Сертификаты (QR-коды) для залов по России и заграницей разные?',
        text: 'Да.'
    },
    {
        title: 'Если у вас остались вопросы, напишите нам в чат 😊',
        text: ''
    }];

export const gpbDragonPassInfo = [
    {
        'title': 'Что это за программа?',
        'text': 'Банк предоставляет вам доступ в бизнес-залы за границей.'
    },
    {
        'title': 'Как получить лимиты на бизнес-залы?',
        'text': 'Количество доступных посещений бизнес-залов зависит от выполнения условий перед Банком.'
    },
    {
        'title': 'Проходы бесплатные?',
        'text': 'Да, Банк начисляет определенное количество бесплатных проходов в зависимости от выполненных условий. Это количество отображается в разделе Бизнес-залы.  '
    },
    {
        'title': 'Как получить визит в бизнес-зал?   ',
        'text': 'Проверьте, входит ли нужный вам аэропорт в программу DragonPass – это можно сделать через поле поиска в разделе Бизнес-залы.Мир. После этого выпишите сертификат, нажав на кнопку «Выписать сертификат».'
    },
    {
        'title': 'Что я получаю после оформления?',
        'text': 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество гостей, которые могут пройти с вами.'
    },
    {
        'title': 'Я могу взять с собой других пассажиров?',
        'text': 'Конечно, просто укажите общее количество людей при оформлении сертификата.'
    },
    {
        'title': 'Могу ли я передавать свой qr-код третьим лицам?',
        'text': 'Нет, qr-код именной и выписан на имя основного держателя карты, третьи лица без вашего присутствия не смогут им воспользоваться.'
    },
    {
        'title': 'Могу ли я приобрести дополнительные визиты, когда у меня закончились бесплатные проходы от Банка?',
        'text': 'Да, вы можете оплатить неограниченное количество проходов. Важно отметить, что купленные проходы не подлежат компенсации.'
    },
    {
        'title': '',
        'text': 'Важно: сертификат на визит одноразовый. Если вы купили сертификат на два визита, а прошёл только один пассажир, сертификат будет считаться использованным.'
    },
    {
        'title': 'А можно отменить оплаченные сертификаты?',
        'text': 'Нет, сертификаты невозвратные.'
    },
    {
        'title': 'При наличии оформленного сертификата я гарантированно могу попасть в нужный мне бизнес-зал?',
        'text': 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        'title': 'Сертификат действует в любом аэропорту?',
        'text': 'Да, купленный сертификат можно использовать в любом зарубежном аэропорту-участнике программы.'
    },
    {
        'title': 'Сколько действует сертификат?',
        'text': '14 дней с момента оплаты'
    },
    {
        'title': 'Сертификаты (QR-коды) для залов заграницей и по России разные?',
        'text': 'Да.'
    },
    {
        'title': 'Почему я не вижу доступных проходов?',
        'text': 'Если вы не видите доступных проходов в разделе Задачи, это может значить, что нам еще не поступила информация от Банка или вы не выполнили требуемые условия для получения привилегий. Вы можете уточнить детали по номеру <a href="tel:+74957191911">+7 495 719 19 11</a> или <a href="tel:88007191911">8 800 719 19 11</a>. К сожалению, это вся информация, которая у нас есть по данному вопросу'
    },
    {
        'title': 'Если у вас остались вопросы, напишите нам в чат 😊',
        'text': ''
    }];

export const otkrytieDragonPassInfo = [
    {
        title: '- Что это за программа?',
        text: '- В дополнение к программе по компенсации проходов в бизнес-залы аэропортов России мы запустили аналогичный сервис для проходов в аэропортах за рубежом с большим (очень! 😊) покрытием (свыше 1000 залов).'
    },
    {
        title: '- Как это работает?',
        text: '- Необходимо приобрести сертификат Dragon Pass на нужное количество проходов в нашем приложении. Один пассажир – один проход. После оплаты сертификат с QR-кодом будет отображаться в разделе «Бизнес-залы.Мир». Данный сертификат нужно предъявить сотруднику бизнес-зала. Важно! Сертификат одноразовый. Если вы купили сертификат на 2 прохода, но пройдет только один пассажир, сертификат будет считаться использованным – таковы правила Dragon Pass.'
    },
    {
        title: '- QR-коды для залов по России и заграницей разные?',
        text: '- К сожалению, да, это совершенно разные программы. В разделе «Бизнес-залы.Россия» используются QR-коды по программе Persona.Aero, а в разделе «Бизнес-залы.Мир» - по программе Dragon Pass.'
    },
    {
        title: '- Количество проходов ограничено?',
        text: '- Да, вам предоставляется определенное количество проходов, доступных к возмещению. Это количество единое для внутренних и зарубежных аэропортов. Количество проходов вы можете уточнить в личном кабинете Банка.'
    },
    {
        title: '- Я могу взять с собой других пассажиров?',
        text: '- Да, укажите общее количество людей при оплате прохода. Но, как было сказано выше, важно понимать, что сертификат одноразовый – если ваши друзья не пройдут с вами, проходы все равно сгорят.'
    },
    {
        title: '- А можно отменить проходы?',
        text: '- К сожалению, нет. Оплаченные сертификаты не подлежат возврату.'
    },
    {
        title: '- Сколько действует сертификат?',
        text: '- 60 дней с момента оплаты.'
    },
    {
        title: '- Сертификат действует в любом аэропорту?',
        text: '- Да, купленный сертификат можно использовать в другом зарубежном аэропорту-участнике программы.'
    },
    {
        title: '- Если мне нужно забронировать бизнес зал, например, на троих человек, мне нужно оформлять три отдельных бронирования?',
        text: '- Вы можете оформить один сертификат с тремя проходами или три отдельных сертификата, но с указанием имени каждого пассажира.'
    },
];

export const alfaDragonPassInfo = [
    {
        title: 'Что это за программа?',
        text: 'Здесь вы можете забронировать бизнес-залы за границей.'
    },
    {
        title: 'Как получить визит в бизнес-зал?',
        text: 'Проверьте, входит ли нужный вам аэропорт в программу DragonPass – это можно сделать через поле поиска в разделе Бизнес-залы.Мир.'
    },
    {
        title: 'Что я получаю после оплаты?',
        text: 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество гостей, которые могут пройти с вами.'
    },
    {
        title: 'Я могу взять с собой других пассажиров?',
        text: 'Конечно. Просто укажите общее количество людей при покупке сертификата.'
    },
    {
        'title': 'Могу ли я передавать свой qr-код третьим лицам?',
        'text': 'Нет, qr-код именной.'
    },
    {
        title: '',
        text: 'Важно: сертификат на визит одноразовый. Если вы купили сертификат на два визита, а прошёл только один пассажир, сертификат будет считаться использованным.'
    },
    {
        title: 'А можно отменить оплаченные сертификаты?',
        text: 'Нет, сертификаты невозвратные.'
    },
    {
        title: 'При наличии оплаченного визита я гарантированно могу попасть в нужный мне бизнес-зал?',
        text: 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        title: 'Сертификат действует в любом аэропорту?',
        text: 'Да, купленный сертификат можно использовать в другом зарубежном аэропорту-участнике программы.'
    },
    {
        title: 'Сколько действует сертификат?',
        text: '30 дней с момента оплаты'
    },
    {
        title: 'Сертификаты (QR-коды) для залов заграницей и по России разные?',
        text: 'Да.'
    },
    {
        title: 'Если у вас остались вопросы, напишите нам в чат 😊',
        text: ''
    }];

export const spbPrivateAirbackInfo = [
    {
        title: 'Что это за программа?',
        text: 'Банк предоставляет вам доступ в бизнес-залы в аэропортах России.'
    },
    {
        title: 'Как получить визиты на бизнес-залы?',
        text: 'Количество посещений бизнес-залов, которые вы можете компенсировать в Банке, зависит от выполнения условий перед Банком.'
    },
    {
        title: 'Как получить визит в бизнес-зал?',
        text: 'Проверьте, входит ли нужный вам аэропорт в программу – это можно сделать через поле поиска в разделе Бизнес-залы.РФ. После этого выпишите сертификат, нажав на кнопку «Пополнить».'
    },
    {
        title: 'Что я получаю после оплаты?',
        text: 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество купленных визитов и спишет требуемое количество. Один пассажир – один визит.'
    },
    {
        title: 'Я могу взять с собой других пассажиров?',
        text: 'Конечно. Просто укажите общее количество людей при Пополнении QR-кода.'
    },
    {
        title: 'А как получить компенсацию?',
        text: 'Вы можете компенсировать расходы за бизнес-залы в аэропортах, просто отправив чек об оплате в разделе «Компенсация чеков». Чек будет доставлен в Банк и компенсирован в соответствии с правилами Банка.'
    },
    {
        title: 'А можно отменить оплаченные визиты?',
        text: 'Да, деньги отправим сразу, как только вы оформите возврат в приложении. Сроки зачисления зависят от вашего банка: обычно это от 1 до 14 дней.'
    },
    {
        title: 'При наличии оплаченного визита я гарантированно могу попасть в нужный мне бизнес-зал?',
        text: 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        title: 'QR-код действует в любом аэропорту?',
        text: 'Да, оплаченные визиты можно использовать в другом аэропорту-участнике программы по России.'
    },
    {
        title: 'Сколько действует QR-код?',
        text: '60 дней с момента оплаты'
    },
    {
        title: 'Сертификаты (QR-коды) для залов по России и заграницей разные?',
        text: 'Да.'
    },
    {
        title: 'Если у вас остались вопросы, напишите нам в чат 😊',
        text: ''
    }];

export const spbPrivateDragonPassInfo = [
    {
        title: 'Что это за программа?',
        text: 'Банк предоставляет вам доступ в бизнес-залы за границей.'
    },
    {
        title: 'Как получить лимиты на бизнес-залы?',
        text: 'Количество посещений бизнес-залов, которые вы можете компенсировать в Банке, зависит от выполнения условий перед Банком.'
    },
    {
        title: 'Как получить визит в бизнес-зал?',
        text: 'Проверьте, входит ли нужный вам аэропорт в программу DragonPass – это можно сделать через поле поиска в разделе Бизнес-залы.Мир. После этого выпишите сертификат, нажав на кнопку «Выписать сертификат».'
    },
    {
        title: 'Что я получаю после оформления?',
        text: 'Вы получаете сертификат в виде QR-кода. Его нужно предъявить сотруднику бизнес-зала со своего смартфона при входе. Просканировав QR-код в сертификате, сотрудник увидит количество гостей, которые могут пройти с вами.'
    },
    {
        title: 'Я могу взять с собой других пассажиров?',
        text: 'Конечно. Просто укажите общее количество людей при покупке сертификата.\n' +
            'Важно: сертификат на визит одноразовый. Если вы купили сертификат на два визита, а прошёл только один пассажир, сертификат будет считаться использованным.'
    },
    {
        title: 'А как получить компенсацию?',
        text: 'Вы можете компенсировать расходы за бизнес-залы в аэропортах, просто отправив чек об оплате в разделе «Компенсация чеков». Чек будет доставлен в Банк и компенсирован в соответствии с правилами Банка.'
    },
    {
        title: 'А можно отменить оплаченные сертификаты?',
        text: 'Нет, сертификаты невозвратные.'
    },
    {
        title: 'При наличии оформленного сертификата я гарантированно могу попасть в нужный мне бизнес-зал?',
        text: 'Зависит от наполненности зала. Обычно места есть всегда, но, если что-то случится, об отсутствии свободных мест вам скажут на ресепшн.'
    },
    {
        title: 'Сертификат действует в любом аэропорту?',
        text: 'Да, купленный сертификат можно использовать в любом зарубежном аэропорту-участнике программы.'
    },
    {
        title: 'Сколько действует сертификат?',
        text: '60 дней с момента оплаты'
    },
    {
        title: 'Сертификаты (QR-коды) для залов заграницей и по России разные?',
        text: 'Да.'
    },
    {
        title: 'Если у вас остались вопросы, напишите нам в чат 😊',
        text: ''
    }];

export const AIRBACK_INFO_TEXTS = [
    {
        service: GPBKEY,
        tariff: '',
        type: 'dragon_pass',
        text: gpbDragonPassInfo
    },
    {
        service: '',
        tariff: OTKRYTIEKEY,
        type: 'dragon_pass',
        text: otkrytieDragonPassInfo
    },
    {
        service: OTKRYTIEKEY,
        tariff: '',
        type: 'dragon_pass',
        text: otkrytieDragonPassInfo
    },
    {
        service: '',
        tariff: ALFAKEY,
        type: 'dragon_pass',
        text: alfaDragonPassInfo
    },
    {
        service: '',
        tariff: ALFAONLYKEY,
        type: 'dragon_pass',
        text: alfaDragonPassInfo
    },
    {
        service: '',
        tariff: ACLUBKEY,
        type: 'dragon_pass',
        text: alfaDragonPassInfo
    },
    {
        service: '',
        tariff: ACLUBKONSIERGEKEY,
        type: 'dragon_pass',
        text: alfaDragonPassInfo
    },
    {
        service: '',
        tariff: MTSTARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: CARCADETARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: TRIALTARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: OTPVIPTARIFFKEY,
        type: 'dragon_pass',
        text: otpDragonInfo
    },
    {
        service: '',
        tariff: OTPPRIVATETARIFFKEY,
        type: 'dragon_pass',
        text: otpDragonInfo
    },
    {
        service: '',
        tariff: OTPTARIFFKEY,
        type: 'dragon_pass',
        text: otpDragonInfo
    },
    {
        service: '',
        tariff: MTSPREMIUMTARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: MTSSTATUSTARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: MTSPRIVATETARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: MTSPREMIUM531733TARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: MTSPRIVATEPLUSTARIFFKEY,
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: MTSTARIFFKEY,
        tariff: '',
        type: 'dragon_pass',
        text: mtsDragonInfo
    },
    {
        service: '',
        tariff: OTKRYTIEKEY,
        type: 'business_lounges',
        text: otkrytiePrivateAirbackInfo
    },
    {
        service: GPBKEY,
        tariff: '',
        type: 'business_lounges',
        text: gpbAirbackInfo
    },
    {
        service: '',
        tariff: ALFAKEY,
        type: 'business_lounges',
        text: alfaAirbackInfo
    },
    {
        service: '',
        tariff: ALFAONLYKEY,
        type: 'business_lounges',
        text: alfaAirbackInfo
    },
    {
        service: '',
        tariff: ACLUBKEY,
        type: 'business_lounges',
        text: alfaAirbackInfo
    },
    {
        service: '',
        tariff: ACLUBKONSIERGEKEY,
        type: 'business_lounges',
        text: alfaAirbackInfo
    },
    {
        service: '',
        tariff: MTSTARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: '',
        tariff: CARCADETARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: '',
        tariff: TRIALTARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: '',
        tariff: OTPPRIVATETARIFFKEY,
        type: 'business_lounges',
        text: otpAirbackInfo
    },
    {
        service: '',
        tariff: OTPVIPTARIFFKEY,
        type: 'business_lounges',
        text: otpAirbackInfo
    },
    {
        service: '',
        tariff: OTPTARIFFKEY,
        type: 'business_lounges',
        text: otpAirbackInfo
    },
    {
        service: '',
        tariff: MTSPREMIUMTARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: '',
        tariff: MTSSTATUSTARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: '',
        tariff: MTSPRIVATETARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: '',
        tariff: MTSPREMIUM531733TARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: '',
        tariff: MTSPRIVATEPLUSTARIFFKEY,
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: MTSTARIFFKEY,
        tariff: '',
        type: 'business_lounges',
        text: mtsAirbackInfo
    },
    {
        service: OTKRYTIEPRIVATEKEY,
        tariff: '',
        type: 'business_lounges',
        text: otkrytiePrivateAirbackInfo
    },
    {
        service: OTKRYTIEPRIVATEKEY,
        tariff: '',
        type: 'dragon_pass',
        text: otkrytiePrivateDragonPassInfo
    },
    {
        service: STAGOTKRYTIEPRIVATEKEY,
        tariff: '',
        type: 'dragon_pass',
        text: otkrytiePrivateDragonPassInfo
    },
    {
        service: SPB_SERVICE_KEY,
        tariff: SPB_PRIVATE_TARIFF_KEY,
        type: 'business_lounges',
        text: spbPrivateAirbackInfo
    },
    {
        service: SPB_SERVICE_KEY,
        tariff: SPB_PRIVATE_TARIFF_KEY,
        type: 'dragon_pass',
        text: spbPrivateDragonPassInfo
    },
    {
        service: SPB_SERVICE_KEY,
        tariff: SPB_SERVICE_KEY,
        type: 'business_lounges',
        text: spbPrivateAirbackInfo
    },
    {
        service: SPB_SERVICE_KEY,
        tariff: SPB_SERVICE_KEY,
        type: 'dragon_pass',
        text: spbPrivateDragonPassInfo
    },
    {
        service: SOVCOM_SERVICE_KEY,
        tariff: '',
        type: 'dragon_pass',
        text: sovcomDragonInfo
    },
    {
        service: '',
        tariff: '',
        type: 'k24-mobile/airback_info',
        text: defaultAirbackInfo
    }
];

export const gpbTransferInfoText = '- Как заказать?' +
    '- Оставьте вашу заявку через форму "Трансферы" в разделе "Задачи" (вкладка справа от чата в нижнем меню)' +
    '- Какое количество доступных поездок?' +
    '- Количество доступных поездок появляется в приложении в день продления вашей подписки. Возможна задержка до 4-х дней. Количество регламентируется Банком. Если вы не видите доступных трансферов в разделе Задачи, это может значить, что нам еще не поступила информация от Банка или вы не выполнили требуемые условия для получения привилегий. Вы можете уточнить детали по номеру <a href="tel:+74957191911">+7 495 719 19 11</a> или <a href="tel:88007191911">8 800 719 19 11</a>. К сожалению, это вся информация, которая у нас есть по данному вопросу' +
    '- Какие правила заказа?' +
    '- Вы можете заказать трансфер не позднее чем за 24 часа для заказа поездки по России (не позднее чем за 4 часа для организации трансфера в Москве и Санкт-Петербурге) и не позднее чем за 48 часов для заказа поездки за рубежом. Трансфером считается поездка, где одна из точек – аэропорт или ж/д вокзал, поездки между адресами по городу не допускаются. Остановки и добавление третьего адреса не допускается также, как и трансферы между различными регионами РФ. Используются машины бизнес-класса (Мерседес E, BMW 5, Hongqi H5, Audi A6 и т.д.), либо комфорт класса (Toyota Camry, Skoda Rapid и пр) в зависимости от города. Марка машины не гарантируется.' +
    '\n\nКоличество трансферов рассчитывается для каждой конкретной поездки. В зависимости от расстояния может быть достаточно одной привилегии или же вам будет предложено списать несколько. На выбор вы также можете сохранить привилегию, доплатив требуемую сумму деньгами' +
    '- Почему я не вижу доступных трансферов?' +
    '- Если вы не видите доступных Трансферов в разделе Задачи, это, может значить, что нам еще не поступила информация от Банка или вы не выполнили требуемые условия для получения привилегий. Либо все привилегии уже потрачены. Вы можете уточнить детали по номеру <a href="tel:+74957191911">+7 495 719 19 11</a> или <a href="tel:88007191911">8 800 719 19 11</a>. К сожалению, это вся информация, которая у нас есть по данному вопросу' +
    '- Сколько трансферов у меня есть?' +
    '- Все зависит от выполнения условий программы банка, от 2 до 10 на календарный год.';

export const TRANSFER_RULES_TEXTS = [
    {
        service: GPBKEY,
        tariff: '',
        text: gpbTransferInfoText
    }
];



// WEBPACK FOOTER //
// ./src/lib/consts.tsx